import React from 'react';
import { Link, navigate } from 'gatsby';
import PropTypes from 'prop-types';

// constants/helpers
import { GAME_MODE_NAMES, GAME_MODES } from '../../lib/constants/modes';
import { initialTableData } from '../../lib/initialTableData';

import { Flex } from '../../../../Atoms/Flex-Grid';
import { Button } from '../../../../Atoms/Buttons';

import Table from '../../components/Elements/Table/Table';
import { TableListingWrapper, Wrapper } from './TableListing.atoms';

const links = {
	single: 'play',
	multi: 'play-with-a-friend',
	arena: 'arena',
};

const TableListing = (props) => {
	const {
		playMode,
	} = props;

	return (
		<Wrapper gap="40px" elementWidth="400px" direction="column" align="center">
			{Object.values(GAME_MODES).map((mode) => {
				const title = GAME_MODE_NAMES[mode];
				const tableData = initialTableData(mode);

				return (
					<div key={mode}>
						<TableListingWrapper
							onClick={
								() => { navigate(`/yamb/${links[playMode]}/?gameMode=${mode}`); }
							}
						>
							<Table rollsLeft={9} tableData={tableData} command={{}} announce={{}} isMyTurn={false} turn={false} hideResults />
						</TableListingWrapper>
						<Flex padding="bl" align="flex-start">
							<Button
								size="small"
								as={Link}
								to={`/yamb/${links[playMode]}/?gameMode=${mode}`}
								href={`/yamb/${links[playMode]}/?gameMode=${mode}`}
							>
								{`Play ${title}`}
							</Button>
						</Flex>
					</div>
				);
			})}
		</Wrapper>
	);
};

TableListing.propTypes = {
	playMode: PropTypes.string.isRequired,
};

export default TableListing;
